export default __webpack_public_path__ + "static/media/pie-blue.98112834.svg";